import React from 'react';
import useBuzzInTotal from '../../hooks/useBuzzInTotal';
import BuzzCountNumber from './BuzzCountNumber';

const BuzzCountTrustLine = ({ theme = 'dark', centered = false }) => {
  const count = useBuzzInTotal();
  return (
    <div class={`mb-5 flex justify-center ${centered ? '' : 'lg:justify-start'}`}>
      <div
        class={`inline-flex items-center rounded-full border border-green-lowkey/60 py-1.5 px-3 ${
          theme === 'light' ? 'bg-gray-900' : 'bg-green-lowkey/5'
        }`}
      >
        <span class="font-space-grotesk-regular text-xs font-normal text-gray-300">
          {count === null ? (
            'Buzzing in guests since 2019'
          ) : (
            <>
              <span class="font-mono font-bold italic tabular-nums text-green-lowkey">
                <BuzzCountNumber count={count} duration={1} />
              </span>{' '}
              guests buzzed in since 2019
            </>
          )}
        </span>
      </div>
    </div>
  );
};

export default BuzzCountTrustLine;
